module.exports = __webpack_public_path__ + "img/sunshine-page_1248.9cc151d2.png";